(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stitch-bag-pick-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bbsBagDetailsReady) return;
    window.__bbsBagDetailsReady = true;

    var lastTrigger = null;

    function openDetails(btn) {
      var card = btn.closest('[data-bag-pick-card]');
      var dlg = card && card.querySelector('[data-bag-details]');
      if (!dlg) return;
      lastTrigger = btn;
      if (typeof dlg.showModal === 'function') {
        dlg.showModal();
      } else {
        dlg.setAttribute('open', '');
      }
      document.documentElement.classList.add('bbs-bag-details-open');
      var scroller = dlg.querySelector('.bbs-bag-details__scroll');
      if (scroller) scroller.scrollTop = 0;
      var g = dlg.querySelector('[data-bag-gallery]');
      if (g) goTo(g, 0, true);
    }

    /* ---------- Panel gallery ---------- */
    function galleryIndex(track) {
      var w = track.clientWidth || 1;
      return Math.round(track.scrollLeft / w);
    }

    function syncGallery(g) {
      var track = g.querySelector('[data-bag-gallery-track]');
      var slides = track.querySelectorAll('[data-bag-zoom]');
      var i = Math.max(0, Math.min(slides.length - 1, galleryIndex(track)));
      var count = g.querySelector('[data-bag-gallery-count]');
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      g.querySelectorAll('[data-bag-gallery-thumb]').forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        if (on && t.parentElement) {
          var p = t.parentElement;
          var l = t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2;
          p.scrollTo({ left: l, behavior: 'smooth' });
        }
      });
      var prev = g.querySelector('[data-bag-gallery-prev]');
      var next = g.querySelector('[data-bag-gallery-next]');
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }

    function goTo(g, i, instant) {
      var track = g.querySelector('[data-bag-gallery-track]');
      if (!track) return;
      track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      if (instant) syncGallery(g);
    }

    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-bag-gallery-track]')) {
        clearTimeout(t.__bbsSync);
        t.__bbsSync = setTimeout(function () { syncGallery(t.closest('[data-bag-gallery]')); }, 60);
      }
    }, true);

    /* ---------- Full-screen lightbox (one shared, built on demand) ---------- */
    var lb = null;

    function buildLightbox() {
      lb = document.createElement('dialog');
      lb.className = 'bbs-lightbox';
      lb.setAttribute('aria-label', 'Image viewer');
      lb.innerHTML =
        '<div class="bbs-lightbox__track" data-lb-track></div>' +
        '<button type="button" class="bbs-lightbox__close" data-lb-close aria-label="Close"><span class="material-symbols-outlined" aria-hidden="true">close</span></button>' +
        '<button type="button" class="bbs-lightbox__arrow bbs-lightbox__arrow--prev" data-lb-prev aria-label="Previous image"><span class="material-symbols-outlined" aria-hidden="true">chevron_left</span></button>' +
        '<button type="button" class="bbs-lightbox__arrow bbs-lightbox__arrow--next" data-lb-next aria-label="Next image"><span class="material-symbols-outlined" aria-hidden="true">chevron_right</span></button>' +
        '<span class="bbs-lightbox__count" data-lb-count aria-live="polite"></span>';
      document.body.appendChild(lb);

      var track = lb.querySelector('[data-lb-track]');
      track.addEventListener('scroll', function () {
        clearTimeout(track.__bbsSync);
        track.__bbsSync = setTimeout(syncLightbox, 60);
      });
      lb.addEventListener('click', function (e) {
        if (e.target.closest('[data-lb-close]')) return lb.close();
        if (e.target.closest('[data-lb-prev]')) return lbGo(lbIndex() - 1);
        if (e.target.closest('[data-lb-next]')) return lbGo(lbIndex() + 1);
        // Tap on the dark area around the photo closes the viewer.
        if (!e.target.closest('img')) lb.close();
      });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); lbGo(lbIndex() - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); lbGo(lbIndex() + 1); }
      });
      lb.addEventListener('close', function () {
        var g = lb.__gallery;
        var idx = lb.__index || 0;
        if (g) {
          goTo(g, idx, true);
          var s = g.querySelectorAll('[data-bag-zoom]')[idx];
          if (s) { try { s.focus({ preventScroll: true }); } catch (err) {} }
        }
      });
    }

    function lbIndex() {
      var track = lb.querySelector('[data-lb-track]');
      return Math.round(track.scrollLeft / (track.clientWidth || 1));
    }

    function lbGo(i, instant) {
      var track = lb.querySelector('[data-lb-track]');
      var n = track.children.length;
      i = Math.max(0, Math.min(n - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      if (instant) syncLightbox();
    }

    function syncLightbox() {
      var track = lb.querySelector('[data-lb-track]');
      var n = track.children.length;
      var i = Math.max(0, Math.min(n - 1, lbIndex()));
      lb.__index = i;
      lb.querySelector('[data-lb-count]').textContent = n > 1 ? (i + 1) + ' / ' + n : '';
      lb.querySelector('[data-lb-prev]').hidden = n < 2 || i === 0;
      lb.querySelector('[data-lb-next]').hidden = n < 2 || i === n - 1;
    }

    function openLightbox(slide) {
      if (!lb) buildLightbox();
      var g = slide.closest('[data-bag-gallery]');
      var slides = g.querySelectorAll('[data-bag-zoom]');
      var track = lb.querySelector('[data-lb-track]');
      track.innerHTML = '';
      slides.forEach(function (s) {
        var wrap = document.createElement('div');
        wrap.className = 'bbs-lightbox__slide';
        var img = document.createElement('img');
        img.src = s.getAttribute('data-full');
        img.alt = s.getAttribute('data-alt') || '';
        img.decoding = 'async';
        wrap.appendChild(img);
        track.appendChild(wrap);
      });
      lb.__gallery = g;
      lb.showModal();
      lbGo(parseInt(slide.getAttribute('data-index'), 10) || 0, true);
      requestAnimationFrame(function () { lbGo(parseInt(slide.getAttribute('data-index'), 10) || 0, true); });
    }

    function closeDetails(dlg) {
      if (!dlg) return;
      if (typeof dlg.close === 'function' && dlg.open) {
        dlg.close();
      } else {
        dlg.removeAttribute('open');
        afterClose();
      }
    }

    function afterClose() {
      if (!document.querySelector('[data-bag-details][open]')) {
        document.documentElement.classList.remove('bbs-bag-details-open');
      }
      if (lastTrigger) {
        try { lastTrigger.focus({ preventScroll: true }); } catch (e) {}
        lastTrigger = null;
      }
    }

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-bag-details-open]');
      if (openBtn) {
        e.preventDefault();
        e.stopPropagation();
        openDetails(openBtn);
        return;
      }
      var zoom = e.target.closest('[data-bag-zoom]');
      if (zoom) {
        openLightbox(zoom);
        return;
      }
      var thumb = e.target.closest('[data-bag-gallery-thumb]');
      if (thumb) {
        goTo(thumb.closest('[data-bag-gallery]'), parseInt(thumb.getAttribute('data-bag-gallery-thumb'), 10) || 0);
        return;
      }
      var gPrev = e.target.closest('[data-bag-gallery-prev]');
      var gNext = e.target.closest('[data-bag-gallery-next]');
      if (gPrev || gNext) {
        var gal = (gPrev || gNext).closest('[data-bag-gallery]');
        var tr = gal.querySelector('[data-bag-gallery-track]');
        goTo(gal, galleryIndex(tr) + (gNext ? 1 : -1));
        return;
      }
      var closeBtn = e.target.closest('[data-bag-details-close]');
      if (closeBtn) {
        closeDetails(closeBtn.closest('[data-bag-details]'));
        return;
      }
      // Tap on the dimmed backdrop (outside the panel) closes the sheet.
      if (e.target.matches && e.target.matches('[data-bag-details]')) {
        closeDetails(e.target);
      }
    });

    document.addEventListener('close', function (e) {
      if (e.target.matches && e.target.matches('[data-bag-details]')) afterClose();
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stitch-faq-list"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-bbs-faq-open-first-desktop]').forEach(function (root) {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    var first = root.querySelector('details');
    if (first) first.open = true;
  });
  } catch(e) { console.error(e); }
})();

})();
